import { AppBox } from "../../../../../commons/components";

export default function MatchStatisticDelete() {
  return (
    <AppBox displayBlock>
      Do you want to delete this statistics permanently? Once you delete it, the action cannot be undone.
    </AppBox>
  );
}
